const Hint = ({ show = false, message = "" }) => {
  if (!show) return null

  return (
    <div className="absolute right-0 top-12 z-40 whitespace-nowrap rounded-lg bg-slate-800 px-3 py-2 text-xs font-medium text-white shadow-lg">
      {message}
      <span className="absolute -top-1 right-4 h-2 w-2 rotate-45 bg-slate-800" />
    </div>
  )
}

export default Hint
